var constants = require('../constants');
var utils = require('../utils');
var sequence = require('./surveys-update-sequence');

var Navigation = (function() {

    var _checkNavigation = function(fields, fieldName, response) {
        return function(dispatch) {
            var nav = utils.getFieldNavigation(fields, fieldName);
            if (nav && nav.length > 0) {
                for (let i = 0; i < nav.length; i++) {
                    var navItem = nav[i];
                    for (let j = 0; j < response.length; j++) {
                        if (navItem && (+response[j].value === navItem.value) && navItem.action) {
                            if (navItem.action.actionType === 'enableSurvey') {
                                const { after } = navItem.action;
                                dispatch(_enableSurvey(navItem.action.surveyId, after));
                            } else if (navItem.action.actionType === 'enable') {
                                const surveyId = navItem.action.surveyId || null;
                                dispatch(_enableSequence(navItem.action.fields, surveyId));
                            } else if (navItem.action.actionType === 'disable') {
                                const surveyId = navItem.action.surveyId || null;
                                dispatch(_disableSequence(navItem.action.fields, surveyId));
                            } else if (navItem.action.actionType === 'reorder') {
                                dispatch(_reorderSequence(navItem.action.fields, navItem.action.location));
                            } else if (navItem.action.actionType === 'goTo') {
                                dispatch(_moveSequence(navItem.action.field));
                            } else if (navItem.action.actionType === 'endSurvey') {
                                dispatch(_invalidateSequence());
                            }
                            break;
                        } else if (navItem && navItem.condition && navItem.condition.type === 'priorAnswer') {
                            if (+response[j].rowValue === navItem.condition.value) {
                                var actionItem = navItem.subNav.filter(function(item) {
                                    return item.value === +response[j].value;
                                });
                                dispatch(_enableSurvey(actionItem[0].action.surveyId));
                            }
                        }
                    }
                    if (navItem && navItem.condition) {
                        if (navItem.condition.type === 'multiple' && response.length > 1) {
                            if (navItem.action.actionType === 'enable') {
                                dispatch(_enableSequence(navItem.action.fields));
                            }
                        }
                    }
                }
            }
        };
    }

    var _enableSurvey = function(surveyId,  after) {
        return function(dispatch, getState) {
            var history = getState().surveys;
            var surveyArray = history.index;

            // If after Id supplied, use that for index. Otherwise use current index
            var currentSurveyIndex = (after && surveyArray.indexOf(after) !== -1) ? surveyArray.indexOf(after) : history.currentSurveyIndex;

            // Do not push multiple instances of follow-up surveys if multiple options selected
            if (surveyArray.indexOf(surveyId) === -1) {
                var newSurveyArray = surveyArray
                    .slice(0, currentSurveyIndex + 1)
                    .concat(surveyId)
                    .concat(surveyArray.slice(currentSurveyIndex + 1));

                dispatch(_updateSurveyList(newSurveyArray))
            }
        };
    }

    var _enableSequence = function(fields, surveyId) {
        return function(dispatch, getState) {
            var history = getState().surveys;
            var entities = getState().entities;
            var surveys = entities.surveys;

            // If surveyId is passed, use that intead of current survey
            var selectedSurveyId = surveyId || utils.getSurveyId(history, history.currentSurveyIndex);

            if (fields && fields.length > 0) {
                for (var i = 0; i < utils.getSequenceLength(surveys, selectedSurveyId); i++) {
                    for (var j = 0; j < fields.length; j++) {
                        var sequenceId = utils.getSequenceId(surveys, selectedSurveyId, i);
                        var currentSequence = utils.getCurrentSequence(entities.sequences, sequenceId);

                        if (fields[j] === currentSequence.field) {
                            dispatch(_toggleSequence(sequenceId, true))
                            break;
                        }
                    }
                }
            }
        };
    }

    var _disableSequence = function(fields, surveyId) {
        return function(dispatch, getState) {
            var history = getState().surveys;
            var entities = getState().entities;
            var surveys = entities.surveys;

            // If surveyId is passed, use that intead of current survey
            var selectedSurveyId = surveyId || utils.getSurveyId(history, history.currentSurveyIndex);

            if (fields && fields.length > 0) {
                for (var i = 0; i < utils.getSequenceLength(surveys, selectedSurveyId); i++) {
                    for (var j = 0; j < fields.length; j++) {
                        var sequenceId = utils.getSequenceId(surveys, selectedSurveyId, i);
                        var currentSequence = utils.getCurrentSequence(entities.sequences, sequenceId);

                        if (fields[j] === currentSequence.field) {
                            dispatch(_toggleSequence(sequenceId, false))
                            break;
                        }
                    }
                }
            }
        };
    }

    var _moveSequence = function(field) {
        return function(dispatch, getState) {
            var sep = field.indexOf('@');
            if (sep > 0) {
                 dispatch(_enableSurvey(field.substring(sep + 1)));
            } else {
                var history = getState().surveys;
                var entities = getState().entities;
                var surveys = entities.surveys;
                var surveyId = utils.getSurveyId(history, history.currentSurveyIndex);

                for (var i = 0; i < utils.getSequenceLength(surveys, surveyId); i++) {
                    var sequenceId = utils.getSequenceId(surveys, surveyId, i);
                    var currentSequence = utils.getCurrentSequence(entities.sequences, sequenceId);

                    if (currentSequence.field === field) {
                        dispatch(sequence.updateSequenceIndex(i - 1));
                        break;
                    }
                    currentSequence.enabled = false;
                }
            }
        };
    }

    var _invalidateSequence = function() {
        return function(dispatch, getState) {
            var history = getState().surveys;
            var entities = getState().entities;
            var surveys = entities.surveys;
            var surveyId = utils.getSurveyId(history, history.currentSurveyIndex);

            for (var i = history.currentSequenceIndex; i < utils.getSequenceLength(surveys, surveyId); i++) {
                var sequenceId = utils.getSequenceId(surveys, surveyId, i);
                var currentSequence = utils.getCurrentSequence(entities.sequences, sequenceId);
                currentSequence.enabled = false;
            }
        };
    }

    var _reorderSequence = function(fields, location) {
        return function(dispatch, getState) {
            var history = getState().surveys;
            var entities = getState().entities;
            var surveys = entities.surveys;

            var surveyId = utils.getSurveyId(history, history.currentSurveyIndex);
            var index = surveys[surveyId].sequence.indexOf(location.field); //move to utils

            var newSequence = surveys[surveyId].sequence.filter(function(item) {
                return fields.indexOf(item) < 0;
            });

            newSequence = newSequence
                .slice(0, index + 1)
                .concat(fields)
                .concat(newSequence.slice(index + 1));

            dispatch(_changeSequence(surveyId, newSequence));

        };
    }

    var _updateSurveyList = function(surveyList) {
        return {
            type: constants.UPDATE_SURVEY_LIST,
            surveyList: surveyList
        };
    }

    var _changeSequence = function(surveyId, sequence) {
        return {
            type: constants.CHANGE_SEQUENCE,
            surveyId: surveyId,
            sequence: sequence
        };
    }

    var _toggleSequence = function(sequenceId, value) {
        return {
            type: constants.TOGGLE_SEQUENCE,
            sequenceId: sequenceId,
            enabled: value
        };
    }

    var _goBack = function(){
        return {
            type: 'GO_BACK_PREVIOUS'
        }
    }

    return {
        checkNavigation: _checkNavigation,
        goBack: _goBack
    }
})();

module.exports = Navigation;



// WEBPACK FOOTER //
// ./src/common/modules/survey/actions/surveys-navigation.js